import React from 'react';
import { CheckCircle2, Hourglass, CheckSquare, XCircle, Activity } from 'lucide-react';

const CHIP = {
  success: 'md-icon-chip md-icon-chip-md md-icon-chip-success',
  warning: 'md-icon-chip md-icon-chip-md md-icon-chip-warning',
  error: 'md-icon-chip md-icon-chip-md md-icon-chip-error',
  primary: 'md-icon-chip md-icon-chip-md md-icon-chip-primary',
};

function StatisticsCards({ stats }) {
  const safeStats = stats || {};

  const cards = [
    {
      key: 'approved',
      value: safeStats.approvedEnrollments ?? 0,
      label: 'Approved Enrollments',
      accent: 'stat-accent-approved',
      icon: CheckCircle2,
      chipClass: CHIP.success,
    },
    {
      key: 'pending',
      value: safeStats.pendingEnrollments ?? 0,
      label: 'Pending Enrollments',
      accent: 'stat-accent-pending',
      icon: Hourglass,
      chipClass: CHIP.warning,
    },
    {
      key: 'completed',
      value: safeStats.completedEnrollments ?? 0,
      label: 'Completed Enrollments',
      accent: 'stat-accent-completed',
      icon: CheckSquare,
      chipClass: CHIP.success,
    },
    {
      key: 'withdrawn',
      value: safeStats.withdrawnEnrollments ?? 0,
      label: 'Withdrawn Enrollments',
      accent: 'stat-accent-withdrawn',
      icon: XCircle,
      chipClass: CHIP.error,
    },
    {
      key: 'activeCohorts',
      value: safeStats.activeCohorts ?? 0,
      label: 'Active Cohorts',
      accent: 'stat-accent-cohorts',
      icon: Activity,
      chipClass: CHIP.primary,
    },
  ];

  return (
    <section>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 'var(--spacing-lg)' }}>
        <h3 className="section-title" style={{ marginBottom: 0 }}>Statistics</h3>
      </div>

      <div className="stat-grid">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.key} className={`stat-card ${c.accent}`}>
              <div className={`stat-icon-box ${c.chipClass}`}>
                <Icon size={20} />
              </div>
              <div className="stat-value">{c.value}</div>
              <div className="stat-label">{c.label}</div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default StatisticsCards;
